import { Environment } from "./interface/environment";

export const environment: Environment = {
    production: false,
  // adminPortalUrl: 'http://localhost:3000/',
  adminPortalUrl: 'https://dev.api.suite7.io/',
  gpPortalAppUrl: 'https://dev.gp.suite7.io/',
};
